import Vue from 'vue';
import Vuex from 'vuex';

import AuthService from '@/services/api/auth.service';
import chamadas from './modules/chamadas';
import processosSeletivos from './modules/processoSeletivo';
import candidatos from './modules/candidatos';

Vue.use(Vuex);

const user = JSON.parse(localStorage.getItem('user'));

export default new Vuex.Store({
  modules: {
    chamadas,processosSeletivos, candidatos
  },
  state: {
    user: user
  },
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.user = user;
    },
    loginFailure(state) {
      state.user = null;
    },
    logout(state) {
      state.user = null;
    },
  },
  getters: {
    isLoggedIn: state => {
      return !!state.user;
    },
    loggedUser: state => {
      return state.user;
    }
  }
});
